import { HomeIcon, Info, LifeBuoy, LogOut, Package, RotateCcw, Settings, ShoppingBag, ShoppingCart, Store } from "lucide-react";

import type { AppSidebarProps } from "@/components/dashboard/app-sidebar";

export const BUYER_SIDEBAR_DATA: AppSidebarProps = {
	navMain: [
		[
			{
				title: "Home",
				url: "/buyer/home",
				icon: HomeIcon,
				isActive: true
			},
			{
				title: "Vendor",
				url: "/buyer/vendor",
				icon: Store
			},
			{
				title: "Orders",
				url: "/buyer/orders",
				icon: ShoppingCart
			},
			{
				title: "Discovery",
				url: "/discovery",
				icon: ShoppingBag
			}
			// Chat - disabled on web, available on mobile app only
			// {
			// 	title: "Chat",
			// 	url: "/buyer/chat",
			// 	icon: MessageCircle
			// }
		],
		[
			{
				icon: Info,
				title: "Dispute",
				url: "/buyer/dispute",
				hasPushNotifications: true
			},
			{
				title: "Settings",
				url: "/buyer/settings",
				icon: Settings
			},
			{
				title: "Support",
				url: "/buyer/support",
				icon: LifeBuoy
			}
		]
	],
	navSecondary: [
		{
			title: "Switch to Vendor",
			url: "",
			icon: RotateCcw
		},
		{
			title: "Logout",
			url: "/discovery",
			icon: LogOut
		}
	]
} as const;
export const VENDOR_SIDEBAR_DATA: AppSidebarProps = {
	navMain: [
		[
			{
				title: "Home",
				url: "/vendor/home",
				icon: HomeIcon,
				isActive: true
			},
			{
				title: "Contract",
				url: "/vendor/contract",
				icon: Store
			},
			{
				title: "Orders",
				url: "/vendor/orders",
				icon: ShoppingCart
			},
			{
				title: "Store",
				url: "/vendor/store",
				icon: Package
			}
			// Chat - disabled on web, available on mobile app only
			// {
			// 	title: "Chat",
			// 	url: "/vendor/chat",
			// 	icon: MessageCircle
			// }
		],
		[
			{
				icon: Info,
				title: "Dispute",
				url: "/vendor/dispute",
				hasPushNotifications: true
			},
			{
				title: "Settings",
				url: "/vendor/settings",
				icon: Settings
			},
			{
				title: "Support",
				url: "/vendor/support",
				icon: LifeBuoy

			}
		]
	],
	navSecondary: [
		{
			title: "Switch to Buyer",
			url: "",
			icon: RotateCcw
		},
		{
			title: "Logout",
			url: "/discovery",
			icon: LogOut
		}
	]
} as const;
